import React from 'react'

import Dialog from '@material-ui/core/Dialog'

import createLogger from 'debug'
import { DialogIcon, DialogTitle } from 'profile/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import DialogActions from '@material-ui/core/DialogActions'
import MuiButton from '@material-ui/core/Button'
import { startDiscussionIntroTour, startOutcomeTour, startRespondingTour } from './startDiscussionTour'
import { usePostLoaded } from 'posts/posts.selectors'
import { FaHandsHelping as WelcomeIcon } from "react-icons/fa"
import { Tab, Tabs } from '@material-ui/core'
import { TabPanel } from 'core/TabPanel'
import { a11yProps } from 'core/a11yProps'
import styled from 'styled-components'
import { getPersonName } from 'components/PersonName'
import ResponsesIcon from 'icons/ResponsesIcon'
import AssistantIcon from 'icons/AssistantIcon'
import { FormattedMessage, useIntl } from 'react-intl'

// to enable localStorage.debug = 'info:*'
const info = createLogger('info:ui')

const IntroContent = () => {
    const post = usePostLoaded()

    return (
        <>
            <div className='post_dialog_intro_en'>
                <Typography gutterBottom>
                    <FormattedMessage id={`post_dialog.pre_welcome`} />&nbsp; <span className="custom_text">‘{post.title}’</span>. &nbsp;<FormattedMessage id={`post_dialog.post_welcome`} />
                </Typography>
                <Typography gutterBottom>
                    <FormattedMessage id={`post_dialog.tour_help`} />
                </Typography>
            </div>
            <div className='post_dialog_intro_ar'>
                <Typography gutterBottom>
                    <FormattedMessage id={`post_dialog.post_welcome`} /> <span className="custom_text"> ‘{post.title}’</span>. <FormattedMessage id={`post_dialog.pre_welcome`} />.
                </Typography>
                <Typography gutterBottom>
                    <FormattedMessage id={`post_dialog.tour_help`} />
                </Typography>
            </div>
        </>
    )
}

const RespondingContent = () => {
    const post = usePostLoaded()

    return (
        <>
            <div className='post_dialog_welcome_en'>
                <Typography gutterBottom>
                    <FormattedMessage id={`post_dialog.line_1`} /> <span className='custom_text'>‘{getPersonName(post.author)}’ </span> &nbsp; <FormattedMessage id={`post_dialog.line_2_1`} /> {<ResponsesIcon />} <FormattedMessage id={`post_dialog.line_2_2`} /> {<ResponsesIcon />} <FormattedMessage id={`post_dialog.line_2_3`} />
                </Typography>
                <Typography gutterBottom>
                    <FormattedMessage id={`post_dialog.tour_help`} />
                </Typography>
            </div>
            <div className='post_dialog_welcome_ar'>
                <Typography gutterBottom>
                    ‘{getPersonName(post.author)}’ <FormattedMessage id={`post_dialog.line_1`} />
                    <FormattedMessage id={`post_dialog.line_2_3`} /> {<ResponsesIcon />} <FormattedMessage id={`post_dialog.line_2_2`} /> {<ResponsesIcon />} <FormattedMessage id={`post_dialog.line_2_1`} />
                </Typography>
                <Typography gutterBottom>
                    <FormattedMessage id={`post_dialog.tour_help`} />
                </Typography>
            </div>
        </>
    )
}

const OutcomeContent = () => {
    const post = usePostLoaded()
    const status = !post.completed ? <FormattedMessage id={`post_dialog.post_welcome`} /> : <FormattedMessage id={`post_dialog.post_closed`} />

    return (
        <>
            <Typography gutterBottom>
                {status} <FormattedMessage id={`post_dialog.line_3`} />
            </Typography><Typography gutterBottom>
                <FormattedMessage id={`post_dialog.tour_help`} />
            </Typography>
        </>
    )
}

const WelcomeContentWrapper = styled.div`
    display: flex;
    flex: auto;
    & .MuiTabs-vertical {
        min-width: 105px;
        border-right: 1px solid ${({ theme }) => theme.palette.divider};
    }
`

const INTRO_TAB = 0
const RESPONDING_TAB = 1
const OUTCOME_TAB = 2

const HelpContent = ({ helpSection, setHelpSection }) => {
    const handleChange = (event, newValue) => {
        setHelpSection(newValue)
    }

    return (
        <WelcomeContentWrapper>
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={helpSection}
                onChange={handleChange}
                aria-label="Vertical tabs example"
            >
                <Tab label={<FormattedMessage id={`post_dialog.tab_1`} />} {...a11yProps(INTRO_TAB)} />
                <Tab label={<FormattedMessage id={`post_dialog.tab_2`} />} {...a11yProps(RESPONDING_TAB)} />
                <Tab label={<FormattedMessage id={`post_dialog.tab_3`} />} {...a11yProps(OUTCOME_TAB)} />
            </Tabs>
            <TabPanel value={helpSection} index={INTRO_TAB}>
                <IntroContent />
            </TabPanel>
            <TabPanel value={helpSection} index={RESPONDING_TAB}>
                <RespondingContent />
            </TabPanel>
            <TabPanel value={helpSection} index={OUTCOME_TAB}>
                <OutcomeContent />
            </TabPanel>
        </WelcomeContentWrapper>
    )
}

export const WelcomeToPostDialog = ({ open, handleClose }) => {
    const post = usePostLoaded()
    if (!post) {
        return null
    }

    const [helpSection, setHelpSection] = React.useState(INTRO_TAB)

    return (
        <Dialog
            onClose={() => handleClose(true)}
            aria-labelledby="customized-dialog-title"
            open={open}
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
        >
            <DialogTitle id="customized-dialog-title"
                onClose={() => handleClose(true)}
                icon={<DialogIcon><AssistantIcon /></DialogIcon>}
            >
                <span data-id="welcome-dialog"><FormattedMessage id={`post_dialog.line_4`} /> </span>
            </DialogTitle>
            <DialogContent dividers>
                <HelpContent helpSection={helpSection} setHelpSection={setHelpSection} />
            </DialogContent>
            <DialogActions>
                <DiscussionTourButton handleClose={handleClose} helpSection={helpSection} />
            </DialogActions>
        </Dialog>
    )
}

export const DiscussionTourButton = ({ handleClose, helpSection = INTRO_TAB }) => {
    const intl = useIntl()


    const takeTour = () => {
        handleClose(true)
        switch (helpSection) {
            case OUTCOME_TAB:
                startOutcomeTour(intl)
                break
            case RESPONDING_TAB:
                startRespondingTour(intl)
                break
            case INTRO_TAB:
                startDiscussionIntroTour(intl)
                break
        }
    }
    return (
        <MuiButton
            onClick={takeTour}
            autoFocus
            color="primary"
            type="submit">
            <FormattedMessage id="post_dialog.button" />
        </MuiButton>
    )
}